<template>
  <form-wrapper>
    <validation-observer
      v-slot="{ valid }"
      ref="regObserver"
    >
      <form-group>
        <form-group-title v-if="!hideSubtitles">
          {{ $t('application-form.step-3.address-subtitle') }}
        </form-group-title>
        <div v-if="disabledFields.includes('registration_address')">
          <input-label>
            {{ $t('application-form.step-3.registration-address') }}
          </input-label>
          <div class="register-value">
            {{ stepFormData.registration_address }}
          </div>
        </div>
        <validation-provider v-else v-slot="{errors}" :rules="getAddressRules()">
          <text-input
            :errors="[...errors, ...getFieldErrors('registration_address')]"
            :value="stepFormData.registration_address"
            :label="$t('application-form.step-3.registration-address')"
            required
            :placeholder="$t('application-form.step-3.address-placeholder')"
            :force-hint-on-focus="true"
            :hint="$t('application-form.step-3.address-hint')"
            @input="emitInput('registration_address', $event)"
          />
        </validation-provider>
      </form-group>
    </validation-observer>
    <div class="form-group">
      <checkbox-input
        :value="stepFormData.registration_is_living"
        @input="emitInput('registration_is_living', $event)"
      >
        {{ $t('application-form.step-3.registration-is-living') }}
      </checkbox-input>
    </div>
    <validation-observer
      v-if="!stepFormData.registration_is_living"
      v-slot="{ valid }"
      ref="liveObserver"
    >
      <form-group>

        <form-group-title v-if="!hideSubtitles">
          {{ $t('application-form.step-3.registration-is-living-subtitle') }}
        </form-group-title>
        <validation-provider v-slot="{errors}" name="regCountry" :rules="getAddressRules()">

          <text-input
            :errors="[...errors, ...getFieldErrors('living_address')]"
            :value="stepFormData.living_address"
            :label="$t('application-form.step-3.living-address')"
            required
            :placeholder="$t('application-form.step-3.address-placeholder')"
            :force-hint-on-focus="true"
            :hint="$t('application-form.step-3.address-hint')"
            @input="emitInput('living_address', $event)"
          />
        </validation-provider>
      </form-group>
    </validation-observer>
    <form-group>
      <validation-provider v-slot="{errors, validate}" slim rules="required_files|files_has_no_errors">
        <icu-dropzone
          v-if="showPhotoRegister"
          :errors="[...getFieldErrors('photo_register'), ...errors]"
          :value="stepFormData.photo_register"
          :is-resident="isResident"
          :label="$t('application-form.step-2.certificate-of-residence')"
          :hint="$t('application-form.step-2.certificate-of-residence-hint')"
          required
          @input="emitFile('photo_register', $event)"
          @files-uploaded="validate"
        />
      </validation-provider>
      <template v-if="showIsMigrant">
        <checkbox-input
          :value="stepFormData.is_internal_migrant"
          :disabled="isMigrantCheckboxDisabled"
          @input="emitInput('is_internal_migrant', $event)"
        >
          {{ $t('application-form.step-3.is-internal-migrant') }}
        </checkbox-input>
        <template v-if="isDiyaCheckData && stepFormData.photo_migrant_reference.length ">
          <div class="register-row">
            <div class="register-label">
              {{ $t('application-form.step-3.migrant-certificate') }}:
            </div>
            <div class="register-value">
              <span v-for="(data,index) in stepFormData.photo_migrant_reference" :key="data.id">
                <span v-if="index > 0">, </span>
                <a
                  :ref="data.uuid"
                  @click="showDoc(data.uuid)"
                >
                  {{ data.name }}
                </a>
              </span>
            </div>
          </div>
        </template>
        <validation-provider
          v-else
          :key="stepFormData.is_internal_migrant"
          v-slot="{errors, validate}"
          slim
          rules="required_files|files_has_no_errors"
        >
          <icu-dropzone
            v-if="stepFormData.is_internal_migrant"
            :label="$t('application-form.step-3.migrant-certificate')"
            :hint="$t('application-form.step-3.migrant-certificate-hint')"
            :errors="[...getFieldErrors('is_internal_migrant'), ...errors]"
            :value="stepFormData.photo_migrant_reference"
            :is-resident="isResident"
            required
            @input="emitFile('photo_migrant_reference', $event)"
            @delete-file="deleteFile('photo_migrant_reference', $event)"
            @files-uploaded="validate"
          />
        </validation-provider>
      </template>
    </form-group>
  </form-wrapper>
</template>

<script>
import FormWrapper from '@/components/views/RegisterPage/FormWrapper.vue'
import FormGroup from '@/components/views/RegisterPage/FormGroup.vue'
import IcuSelect from '@/components/inputs/IcuSelect.vue'
import TextInput from '@/components/inputs/TextInput.vue'
import CheckboxInput from '@/components/inputs/CheckboxInput.vue'
import FormGroupTitle from '@/components/views/RegisterPage/FormGroupTitle.vue'
import IcuDropzone from '@/components/inputs/IcuDropzone.vue'
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import { get } from 'lodash'
import { api } from '@/api/api.js'
import InputLabel from '@/components/inputs/InputLabel'

export default {
  name: 'ThirdStep',
  components: {
    InputLabel,
    IcuDropzone,
    ValidationProvider,
    ValidationObserver, FormGroupTitle, CheckboxInput, TextInput, IcuSelect, FormGroup, FormWrapper },
  props: {
    disabledFields: {
      type: Array,
      default: () => []
    },
    stepFormData: {
      type: Object,
      required: true
    },
    backendErrors: {
      type: Object,
      default: () => {}
    },
    isResident: {
      type: Boolean,
      required: true
    },
    isCitizen: {
      type: Boolean,
      required: true

    },
    hideSubtitles: {
      type: Boolean,
      default: false
    },
    isMigrantCheckboxDisabled: {
      type: Boolean,
      default: false
    },
    isDiyaCheckData: {
      type: Boolean,
      default: false
    }
  },
  computed:{
    showPhotoRegister(){
      // return this.blackListCountries.includes(this.stepFormData.registration_address.country) &&
      //     !this.stepFormData.registration_is_living &&
      //     !this.blackListCountries.includes(this.stepFormData.living_address.country)
      return false
    },
    showIsMigrant(){
      if( !this.isResident && !this.isCitizen) {
        return false
      }
      return true
    },
    lang(){
      return this.isResident? 'uk' : 'en'
    },
  },
  async mounted(){
    if(this.stepFormData.registration_address) {
      await this.$refs.regObserver.validate()
    }
    if(this.stepFormData.living_address) {
      await this.$refs.liveObserver.validate()
    }
  },
  methods: {

    getAddressRules() {
      const rules = {
        required: true
      }
      return rules
    },

    emitInput(formKey, value) {
      this.$emit('update-field', {formKey, value})
    },
    emitFile(formKey, file) {
      this.$emit('add-file', {formKey, file})
    },
    deleteFile(formKey, file) {
      this.$emit('delete-file', {formKey, file})
    },
    getFieldErrors(fieldName) {
      return get(this.backendErrors, fieldName, [])
    },
    async showDoc(id, name){
      try{
        const img = this.$refs[id]
        const res = await api.profile.downloadDoc(id)
        const blob = new Blob([res.data], { type: 'application/pdf' })
        const url = window.URL || window.webkitURL
        const link = url.createObjectURL(blob)
        const a = document.createElement('a')
        a.setAttribute('href', link)
        if(/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
          a.setAttribute('target', '_blank')
        }
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)

      }catch(err){
        console.log(err)
        this.$toast.error(this.$t('notifications.something-went-wrong'))
      }
    },
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/theme.scss";
.register-value {
  color: $gray-2;
}
.register {
  &-row {
    display: flex;
    justify-content: space-between;
    font-size: 15px;
    color: $gray-2;
    & > div {
      flex-basis: 50%;
      color: inherit;
    }

  }
  &-label {
    font-weight: 700;
    color: inherit;
  }
  &-group-title {
    padding-bottom: 15px;
  }
}
a:hover {
  cursor: pointer;
}
.btn-hint {
  color: #858585;
  font-size: 12px;
  font-weight: 700;
  padding-bottom: 10px;
}

.buttons {
  padding-top: 50px;
}

.register-row a {
  color: #295770;
  text-decoration: underline;
}

.diya-check {
  grid-row-gap: 20px;
}
</style>
